import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import SafetyOutlinedSvg from "@ant-design/icons-svg/es/asn/SafetyOutlined";
import AntdIcon from "../components/AntdIcon";
var SafetyOutlined = function SafetyOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: SafetyOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  SafetyOutlined.displayName = 'SafetyOutlined';
}
export default /*#__PURE__*/React.forwardRef(SafetyOutlined);